import { Output, Component, Input, EventEmitter, OnInit } from "@angular/core";
import { EButtonType } from "../../../data-types/button.enum";
import { iconsLibrary } from "../../../../theme/constants";

@Component({
  selector: "cowing-button",
  templateUrl: "./cowing-button.component.html",
  styleUrls: ["./cowing-button.component.scss"],
})
export class CowingButtonComponent implements OnInit {
  @Input("label") label: string;
  @Input("type") type: EButtonType = EButtonType.Primary;
  @Input("isSubmit") submit: boolean = false;
  @Input("disabled") disabled: boolean = false;
  @Input("iconShow") iconShow: boolean = false;
  @Input("iconName") iconName: string = "";
  @Input("isLoading") isLoading: boolean = false;
  @Input("logoType") logoType: string = "";

  @Output("event") onClickEvent = new EventEmitter();
  iconsLibrary;
  public classList = [];
  ngOnInit() {}

  get classesApplied() {
    const classList = [];
    if (this.disabled) {
      classList.push("button-disabled");
    }
    if (!this.disabled) {
      classList.push(`button-${this.type}`);
    }
    if (this.logoType.length) {
      classList.push(`${this.logoType}`);
    }
    return classList;
  }
  onClick(event) {
    this.onClickEvent.emit(event);
  }
  public get getIcon() {
    return `${iconsLibrary[this.iconName]}`;
  }
}
